import { HeadingWithUnderline } from '@components/ui/heading/HeadingWithUnderline'
import { NewsFeed } from '@type/buzzkuri/programs'
import React from 'react'

type Props = {
  feedItems: NewsFeed[]
}

export const NewArrivalsColumn = ({ feedItems }: Props): JSX.Element => (
  <section>
    <div className="flex flex-col justify-start w-[87.2vw] lg:w-[65.2vw]">
      <HeadingWithUnderline heading="新着コラム" Tag="h2" />
      <div className="flex flex-col mt-[8.5vw] lg:mt-[2.5vw]">
        {feedItems.map((feed, i) => (
          <a
            key={i}
            className="inline-block mb-[4.8vw] last:mb-0 lg:mb-[1.7vw] text-[3.2vw] lg:text-[1.1vw] font-bold text-[#EF9B5B]"
            href={feed.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {feed.title}
          </a>
        ))}
      </div>
    </div>
  </section>
)
